import React from 'react';
import './InfoVoucherPage.scss';
import Spinner from 'Components/Shared/Spinner/Spinner';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import FormVoucherPurchaseContainer from 'Components/FormVoucherPurchase/FormVoucherPurchaseContainer';

interface IProps {
  isFetching: boolean;
  descriptionText: string;
  descriptionImageUrl: string;
}

const InfoVoucherPage: React.SFC<IProps> = ({ 
  isFetching,
  descriptionText,
  descriptionImageUrl,
}) => {

  if (isFetching) {
    return (
      <WrapperLayout>
        <Spinner height='lg' />
      </WrapperLayout>
    );
  }

  return (
    <>
      { descriptionText && descriptionImageUrl &&
        <WrapperLayout style='info-voucher-page description' padding='md'>
          <div className='text-container'>
            <FormattedText 
              style='title'
              displayName='Presentkort'
              formattedName='voucher.header'
            />
            <div dangerouslySetInnerHTML={ { __html: descriptionText } } />
          </div>
          <div className='image-container'>
            <img alt='Man med presentkort i bakfickan' src={ descriptionImageUrl } />
          </div>
        </WrapperLayout>
      }
      <WrapperLayout style='info-voucher-page purchase'>
        <WrapperBox>
          <FormVoucherPurchaseContainer />
        </WrapperBox>
      </WrapperLayout>
    </>
  );
}

export default InfoVoucherPage;


// WEBPACK FOOTER //
// ./src/pages/InfoVoucherPage/InfoVoucherPage.tsx